export default __webpack_public_path__ + "static/media/amberImg1.0f26309e.png";